import { useStoreDiyForm } from '@/store/diyform'
import { getFile } from '@/api/seal/seal'
export const useDealFormItems = () => {
  const diyForm = useStoreDiyForm()
  // 提交申请展示-处理控件数据
  const dealControlData = async (data) => {
    const copyDataItemList = JSON.parse(data.formItems)
    // 只有重新提交的时候走这个函数
    if (data.documentId) {
      await dealResubmitDataEcho(
        data.documentId,
        data.formData,
        copyDataItemList,
        data.fileElseList
      )
    }
    copyDataItemList.forEach((item, index) => {
      if (item.type && item.type === 'TAKE_OUT') {
        if (item.props.showTakeOut) {
          item.props.items.forEach((i) => {
            if (i.configName == 'Address') {
              i.props.isMultipleAddress = item.props.isMultipleAddress
            }
          })
          item.props.items.forEach((el, inde) => {
            el.id = 'TakeOut' + inde
          })
        } else {
          copyDataItemList.splice(index, 1)
        }
      }
      if (item.type && item.type === 'SEAL_INFO' && data.formData) {
        const dataItem = data.formData[item.id]
        diyForm.sealFormData.forms = []
        dataItem.forEach((el) => {
          diyForm.sealFormData.forms.push({
            sealId: el.sealId,
            affixedType: el.affixedType,
            applicationNumber: el.applicationNumber
          })
        })
      }

      if (item.type === 'SEAL_INFO') {
        //盖印人选项列表
        let customSeal = item.props.items[item.props.items?.length - 1]
        const stamp = customSeal.props.stamp || []
        diyForm.sealFormData.sealerList = stamp.length ? stamp : null
        const cur = stamp.find((item) => item.isCheck) || {}
        switch (cur.title) {
          case '申请人':
            diyForm.sealFormData.defaultType = 1
            break
          case '保管员':
            diyForm.sealFormData.defaultType = 2
            break
          default:
            diyForm.sealFormData.defaultType = 2
        }
      }

      if (item.type === 'REMOTE') {
        item.resData = data
        //二维码水印配置
        diyForm.setQrcodeConfig({
          qrcodeType: data.qrcodeType ?? 2, //二维码水印开关 1开，2关
          qrcodePageType: data.qrcodePageType ?? 1, //单文件或单页 1.单文件 2.单页
          qrcodeSize: data.qrcodeSize ?? 2, //二维码大小 默认 25*25mm
          qrcodePositionType: data.qrcodePositionType ?? 1 //二维码位置 默认左上
        })
      }
    })
    // 我是所有控件 copyDataItemList
    copyDataItemList.forEach((item) => {
      item.ocrType = data.ocrType
    })
    diyForm.setFomrItems(copyDataItemList)
    diyForm.setNeedId(data.processId, data.processDefinitionId)

    // 获取盖印方式索引
    const index = copyDataItemList.findIndex((item) => {
      return item.type && item.type === 'REMOTE'
    })
    if (index > -1) {
      // 处理盖印方式选项数组
      const option = []
      copyDataItemList[index].props.options.forEach((item) => {
        typeof item !== 'string'
          ? item.isOpen
            ? option.push(item.name)
            : ''
          : option.push(item)
      })
      copyDataItemList[index].props.options = option
      const list = ['常规盖印', '远程盖印', '连续盖印']
      if (!diyForm.form[copyDataItemList[index].id]) {
        diyForm.form[copyDataItemList[index].id] = [
          {
            remote:
              list.findIndex(
                (el) => el === copyDataItemList[index].props.options[0]
              ) + 1
          }
        ]
      }
      remoteVal(data, copyDataItemList[index].id)
    }

    // 拿到印章列表和保管员列表\
    diyForm.sealFormData.sealAllList = data.sealList
    data?.sealList?.forEach((item) => {
      item.isChecked = false
      diyForm.sealFormData.keeperObj[item.sealId] = item.trusteeList
    })
    localStorage.setItem('diyForm', JSON.stringify(diyForm.$state))
  }

  // 只有一个远程确认人时，不用去选择确认人，远程参数塞过去
  const remoteVal = (data, itemId) => {
    let _resData = data
    let list = _resData.remoteAuditorVO
    let hasSelf = _resData.hasSelf
    if (list != null && list.length === 1) {
      diyForm.form[itemId][0]['remoteStaffId'] = list[0].id
      diyForm.form[itemId][0]['remoteStaff'] = {
        staffId: list[0].id,
        staffName: list[0].name,
        avatarId: list[0].avatarId,
        fullAvatar: list[0].fullAvatar
      }
    }
  }

  // 重新提交-数据回填函数
  const dealResubmitDataEcho = async (
    recordId,
    formData,
    itemList,
    fileElseList
  ) => {
    diyForm.setResubmitId(recordId)
    let obj = {}
    for (const item of itemList) {
      if (formData[item.id]) {
        // 属于固定类型的
        if (item.type) {
          obj[item.id] = dealFixTypeData(formData, item, fileElseList)
        } else {
          obj[item.id] = await dealCustData(formData, item)
        }
      }
    }
    diyForm.setResubmitDataEcho(obj)
  }
  // 处理固定数据
  const dealFixTypeData = (formData, item, fileElseList) => {
    let valueData = {}
    switch (item.type) {
      case 'FILE_ELSE':
        valueData = formData[item.id].map((elem) => {
          const index = fileElseList.findIndex(
            (el) => el.fileId === elem.fileId
          )
          return fileElseList[index]
        })
        break
      case 'FILE_NAME':
        valueData = formData[item.id][0].fileName
        break
      case 'SEAL_INFO':
        formData[item.id].forEach((el) => {
          valueData = []
          valueData.unshift({
            sealId: el.sealId,
            affixedType: el.affixedType,
            applicationNumber: el.applicationNumber
          })
          diyForm.sealFormData.forms = valueData
        })
        break
      case 'REMOTE':
        valueData = formData[item.id]
        if (formData[item.id][0].remote === 2) {
          valueData[0]['remoteStaffId'] =
            formData[item.id][0].remoteStaff?.staffId || ''
        }
        break
      case 'TAKE_OUT':
        if (formData[item.id][0].takeout === 2) {
          valueData = [{ takeout: formData[item.id][0].takeout }]
          diyForm.form['TakeOut1'] = formData[item.id][0].addressList
          diyForm.form['TakeOut0'] = [
            formData[item.id][0].startTime,
            formData[item.id][0].finishTime
          ]
        } else {
          valueData = [{ takeout: formData[item.id][0].takeout }]
        }
        break
      default:
        valueData = formData[item.id]
        break
    }
    return valueData
  }
  // 处理自定义数据
  const dealCustData = async (formData, item) => {
    let valueData
    if (item.controlName === 'FileUpload') {
      const ids = formData[item.id].map((item) => item.fileId)
      const { code, data } = await getFile({
        ids: ids.join(','),
        isPagination: false
      })
      if (code === 0) {
        valueData = data.map((item) => {
          item.fullFile = item.fullUrl
          item.fileName = item.name
          item.fileId = item.id
          return item
        })
      }
    } else {
      valueData = formData[item.id]
    }
    return valueData
  }
  return {
    dealControlData,
    dealResubmitDataEcho
  }
}
